import {ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {AnyPlayable} from '../../engine/playable/playable';
import {PlayableFactoryService} from './playable-factory.service';
import {Store} from '@ngxs/store';


@Component({
  selector: 'gg-video-panel',
  templateUrl: './video-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoPanelComponent implements OnInit, OnDestroy {
  @ViewChild('video') video: ElementRef;

  private playable: AnyPlayable;
  private sub: Subscription;

  constructor(private playableFactory: PlayableFactoryService, private store: Store) {
  }

  ngOnInit() {
    this.sub = this.store.select(state => state.player.src).subscribe(async () => {
      if (this.playable) {
        this.playable.destroy();
      }
      this.playable = await this.playableFactory.setupVideo(this.video.nativeElement);
      console.log({playable: this.playable});
    });
  }

  ngOnDestroy(): void {
    console.log('gg-video-panel ngOnDestroy', {playable: this.playable});

    this.playableFactory.destroy();
    if (this.playable) {
      this.playable.destroy();
    }
    this.sub.unsubscribe();
  }
}
